<template>
  <div>
    <QuantityCheck
      :maintenanceId=maintenanceId
      :normalTemperatureItems=normalTemperatureItems
      :refrigeratedItems=refrigeratedItems
      :checkList=checkList
      type='loss'
      @changeCheckbox=changeCheckbox
      @finish=finish
      @back=back
    ></QuantityCheck>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import QuantityCheck from '@/components/parts/QuantityCheck';

  export default {
    name: 'LossCheck',
    components: {
      QuantityCheck,
    },
    created() {
      this.$parent.title = 'ロス数確認';
      this.$parent.imageName = '';
      this.$parent.hasMaintenancne = false;
      this.checkList = this.setCheckList;
    },
    data() {
      return {
        normalTemperatureItems: this.$store.getters.items(1)
          .filter(item => item.lossQuantity != 0),
        refrigeratedItems: this.$store.getters.items(2)
          .filter(item => item.lossQuantity != 0),
        checkList: {},
      };
    },
    computed: {
      ...mapGetters([
        'maintenanceId',
      ]),
      setCheckList: function() {
        return {
          1: Object.assign({}, ...this.normalTemperatureItems.map((v) => ( { [v.itemId]: false, } ))),
          2: Object.assign({}, ...this.refrigeratedItems.map((v) => ( { [v.itemId]: false, } ))),
        };
      },
    },
    methods: {
      finish(conditionTypeId) {
        const params = {
          maintenanceId: this.maintenanceId,
          conditionTypeId: conditionTypeId,
          type: 'loss',
        };
        this.$store.dispatch('updateCheckStatus', params)
          .then(() => { this.$router.push({ name: 'LossCheck' }); })
          .catch((e) => {
            if (e.status == 401) {
              alert(e.data.error.message);
              this.$router.push({ name: 'SignIn', replace: true });
              return;
            }
            alert(e.data.error.message);
          });
      },
      back: function() {
        this.$router.push({ name: 'MaintenanceCheck' })
      },
      changeCheckbox: function(e, conditionTypeId, itemId) {
        this.checkList[conditionTypeId][itemId] = e;
        const element = document.getElementById(`finish-btn${conditionTypeId}`);
        element.disabled = Object.values(this.checkList[conditionTypeId]).filter(v => !v).length > 0;
      },
    },
  }
</script>

<style lang="scss" scoped>
  div {
    padding-top: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/LossCheck.vue?b1ecdda8